import gql from 'graphql-tag';

export const GET_MERCHANT_VENUE_SEARCH_RESULTS = gql`
  query GetMerchantVenueSearchResults($params: MerchantVenueSearchInput!) {
    searchMerchantVenues(params: $params) {
      result {
        offerNetworkVenueId
        venueName
        locationId
        offerNetworkExternalVenueId
        status
        address1
        address2
        city
        state
        country
        postalCode
        latitude
        longitude
        imageUrl
        venueType
        locationCreationDate
        merchantName
        cardNetworkStatus {
          VISA
          MASTERCARD
          AMEX
        }
        totalTransactions
      }
      pagination {
        nextOffset
        hasNextPage
      }
    }
  }
`;

export default GET_MERCHANT_VENUE_SEARCH_RESULTS;
